import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

import App from './App';
import Store from './Store';
import Payment from './Payment';
import Shipping from './Shipping';
import Contact from './Contact';
import { CartProvider } from './CartContext';

const router = createBrowserRouter([
  { path: '/', element: <App /> },
  { path: '/store', element: <Store /> },
  { path: '/payment', element: <Payment /> },
  { path: '/shipping', element: <Shipping /> },
  { path: '/contact', element: <Contact /> }, 
]);

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CartProvider>
      <RouterProvider router={router} />
    </CartProvider>
  </React.StrictMode>
);
